export default {
  // ── Navigation ────────────────────────────────────────────────────────────
  'home.nav.how_it_works': 'How It Works',
  'home.nav.useCases': 'Use Cases',
  'home.nav.platform_stack': 'Platform Stack',
  'home.nav.pricing': 'Pricing',
  'home.nav.login': 'Log In',
  'home.nav.getStarted': 'Get Started',

  // ── Hero ──────────────────────────────────────────────────────────────────
  'home.hero.badge':
    'From the team behind GameBot — trusted by Tencent, Garena & 20+ studios',
  'home.hero.titleSuffix1': 'Your AI Stack into',
  'home.hero.titleSuffix2': 'One Platform',
  'home.hero.desc':
    // eslint-disable-next-line max-len
    '<span class="text-white/90 font-semibold">Small teams</span> don\'t need <span class="text-white/90 font-semibold">months</span> to assemble infrastructure. Build with\n workflows or code, then deploy, monitor, and control cost on <span class="text-white/90 font-semibold">one production stack\n</span> — built from <span class="text-blue-600 font-semibold">7 years</span> of infrastructure that powers <span class="text-blue-600 font-semibold">Tencent</span> & <span class="text-blue-600 font-semibold">Garena</span>.',
  'home.hero.cta': 'Start Building',
  'home.hero.freeBadge': '$10 Free',
  'home.hero.noCreditCard': 'No credit card required',
  'home.hero.stat.years': 'Years in Production',
  'home.hero.stat.countries': 'Countries Served',
  'home.hero.stat.concurrent': 'Peak Concurrent Agents',
  'home.hero.stat.studios': 'Top Game Studios',

  'home.hero.stats.description': `Since 2019, <span style="color: #4c4ce9; font-weight: bold;">GameBot</span> has powered AI agents for the world's top studios. 
<span style="color: #4c4ce9; font-weight: bold;">Knit</span> puts that same production stack in your hands.`,

  // ── Logo Carousel ─────────────────────────────────────────────────────────
  'home.logos.label':
    'Born from powering these studios. Now yours to build on.',

  // ── Why Now ───────────────────────────────────────────────────────────────
  'home.whyNow.title': 'Why Now?',
  'home.whyNow.desc':
    'AI is shifting from demos to products. The bottleneck is no longer model access alone, but the production stack around agents and AI apps — runtime, observability, cost control, monetization, and operations.',
  'home.whyNow.quote':
    'exists so lean teams can ship without building that stack themselves.',
  'home.whyNow.quotePrefix': 'exists so ',
  'home.whyNow.quoteHL1': 'lean teams',
  'home.whyNow.quoteMid1': ' can ',
  'home.whyNow.quoteHL2': 'ship',
  'home.whyNow.quoteMid2': ' without building that ',
  'home.whyNow.quoteHL3': 'stack',
  'home.whyNow.quoteSuffix': ' themselves.',
  'home.whyNow.quoteBold': 'Knit',
  'home.whyNow.bottomPrefix':
    'Built on 7 years of GameBot infrastructure — serving ',
  'home.whyNow.bottomHighlight1': 'Tencent',
  'home.whyNow.bottomMiddle': ', ',
  'home.whyNow.bottomHighlight2': 'Garena',
  'home.whyNow.bottomSuffix': ', and 20+ studios at ',
  'home.whyNow.bottomHighlight3': '3M concurrent scale',
  'home.whyNow.bottomEnd': '.',
  'home.whyNow.t1.title': 'GAMEBOT FOUNDED',
  'home.whyNow.t1.desc': 'First enterprise deployments',
  'home.whyNow.t2.title': '',
  'home.whyNow.t2.desc': '3M concurrent scale, 20+ studios served',
  'home.whyNow.t3.title': '',
  'home.whyNow.t3.desc': 'AI shifts from demos to agentic products',
  'home.whyNow.t4.title': 'KNIT LAUNCHES',
  'home.whyNow.t4.desc': 'Available to all developers.',

  // ── Capabilities ──────────────────────────────────────────────────────────
  'home.capabilities.label': 'How It Works',
  'home.capabilities.titlePrefix': 'From Prototype To Production',
  'home.capabilities.titleMiddle': 'Without Building Your',
  'home.capabilities.titleHighlight': 'Own Stack.',
  'home.capabilities.subtitle':
    'Build fast. Launch on a managed runtime. Run it with full visibility.',
  'home.capabilities.card1.step': '01',
  'home.capabilities.card1.category': 'BUILD',
  'home.capabilities.card1.title': 'Workflows Or Code',
  'home.capabilities.card1.desc':
    'Start with a <span class="cap-hl">copilot</span>-assisted\n workflow, or bring <span class="cap-hl">your own</span>\n application and service logic\n when you need more <span class="cap-hl">control</span>.',
  'home.capabilities.card2.step': '02',
  'home.capabilities.card2.category': 'DEPLOY',
  'home.capabilities.card2.title': 'Managed Runtime',
  'home.capabilities.card2.desc':
    '<span class="cap-hl">Deploy</span> to a <span class="cap-hl">production</span> environment\n with hosting, releases, rollbacks, and\n scaling <span class="cap-hl">handled for you</span>.',
  'home.capabilities.card3.step': '03',
  'home.capabilities.card3.category': 'OPERATE',
  'home.capabilities.card3.title': 'Cost, Monitoring, Monetization',
  'home.capabilities.card3.desc':
    'Track usage, errors, and spend in <span class="cap-hl">one\n place</span>, with <span class="cap-hl">billing</span> and monetization\n rolling out for <span class="cap-hl">selected teams</span>.',

  // ── Teams ─────────────────────────────────────────────────────────────────
  'home.teams.label': 'Built For',
  'home.teams.titlePrefix': 'Built For The Teams Most Likely\n To ',
  'home.teams.titleHighlight': 'Win With AI.',
  'home.teams.desc':
    "Whether you're a small AI startup searching for product-market fit, a product engineer shipping agentic apps, or a game team with real-time AI workloads — you all hit the same infrastructure wall. Knit helps you ship without building it yourself.",
  'home.teams.card1.quote':
    'A 3-person AI startup with no infra experience. They describe their product to Copilot, it generates the workflow, provisions a database, and deploys — all before dinner. No Docker, no YAML, no DevOps hire.',
  'home.teams.card1.tag': 'Technical Founder \u2022 AI Startup',
  'home.teams.card1.title': 'Idea to live product in one afternoon',
  'home.teams.card2.quote':
    'A 4-person team about to hire two backend engineers just for deployment and monitoring. With Knit, they cancel the job postings, ship their MVP in a week, and keep that runway for product iteration.',
  'home.teams.card2.tag': 'Early-Stage \u2022 AI Startup',
  'home.teams.card2.title': 'Skip the infra hires, ship the MVP',
  'home.teams.card3.quote':
    "A game studio founder who's built large-scale infra at top studios before. This time, instead of rebuilding from scratch, they deploy on Knit — same caliber of infrastructure, none of the overhead. 100K concurrent AI players, handled.",
  'home.teams.card3.tag': 'Indie Game Studio',
  'home.teams.card3.title': '100K concurrent AI players, zero infra team',

  // ── Stack Grid ────────────────────────────────────────────────────────────
  'home.stack.label': 'Platform Stack',
  'home.stack.titlePrefix': 'The Production Stack Most AI Teams',
  'home.stack.titleHighlight': 'End Up',
  'home.stack.titleSuffix': ' Assembling By Hand.',
  'home.stack.subtitle':
    'Knit brings the workflow layer, runtime layer, and operations layer into one platform.',
  'home.stack.item1.title': 'Workflow and Agent Builder',
  'home.stack.item1.desc':
    'Use copilot-assisted workflows and visual orchestration as the fastest path from idea to a working AI product.',
  'home.stack.item2.badge': 'PRIVATE BETA',
  'home.stack.item2.title': 'Managed App Runtime',
  'home.stack.item2.desc':
    'Deploy code-based apps and services with builds, releases, and rollbacks handled for you on the same stack.',
  'home.stack.item3.badge': 'ROLLING OUT',
  'home.stack.item3.title': 'Billing and Monetization',
  'home.stack.item3.desc':
    'Usage-based pricing and subscriptions for selected teams selling AI products on top of Knit.',
  'home.stack.item4.title': 'Observability and Monitoring',
  'home.stack.item4.desc':
    'Inspect failures, watch performance, and monitor production behavior across workflows, agents, and apps.',
  'home.stack.item5.title': 'Significant Cost Savings',
  'home.stack.item5.desc':
    "Lower compute and API costs through large-scale resource pooling across GameBot's existing infrastructure.* Track spending per agent, API call, and resource in real time.",
  'home.stack.item6.title': 'Global Infrastructure',
  'home.stack.item6.desc':
    'Battle-tested across 65 countries and shaped by real-time workloads that demanded scale, resilience, and tight cost discipline.',

  // ── Platform Replace ──────────────────────────────────────────────────────
  'home.platform.badge': 'Why It Wins',
  'home.platform.titleHighlight': 'Replace',
  'home.platform.titleSuffix':
    ' A Fragmented AI Stack With One Production Platform.',
  'home.platform.subtitle1':
    'Most teams end up stitching together workflow tools, hosting,',
  'home.platform.subtitle2': 'dashboards, payments, and custom ops glue.',
  'home.platform.subtitle3':
    'Knit compresses that stack into one system built for AI products.',
  'home.platform.vs': 'VS',
  'home.platform.before.label': 'FRAGMENTED STACK',
  'home.platform.before.title': '5+ tools',
  'home.platform.before.desc':
    'Workflow builder + hosting + dashboards + payments + custom ops glue',
  'home.platform.before.item1':
    'Workflow and runtime live in different systems',
  'home.platform.before.item2':
    'Observability and cost tooling bolted on later',
  'home.platform.before.item3': 'Monetization stitched together separately',
  'home.platform.before.item4': 'Scaling logic spread across vendors',
  'home.platform.before.item5': 'More glue code as the product grows',
  'home.platform.after.label': 'WITH KNIT',
  'home.platform.after.titleNum': '1',
  'home.platform.after.titleText': 'Platform',
  'home.platform.after.desc':
    'One stack for building, deploying, operating, and monetizing AI apps',
  'home.platform.after.item1': 'Workflow and runtime on the same platform',
  'home.platform.after.item2': 'Monitoring and cost controls built in',
  'home.platform.after.item3':
    'Monetization layer rolling out on the same stack',
  'home.platform.after.item4': 'A production path from prototype to scale',
  'home.platform.after.item5': 'Less infra work, more product velocity',

  // ── Platform Compare Table ──────────────────────────────────────────────
  'home.platform.compare.label': 'COMPARISON',
  'home.platform.compare.col1': 'Knit',
  'home.platform.compare.col2': 'Workflow Builders',
  'home.platform.compare.col3': 'Generic Hosting',
  'home.platform.compare.col4': 'Self-Built',
  'home.platform.compare.row1': 'AI workflow builder',
  'home.platform.compare.row2': 'Managed app runtime',
  'home.platform.compare.row3': 'Observability',
  'home.platform.compare.row4': 'Cost controls',
  'home.platform.compare.row5': 'Billing and monetization',
  'home.platform.compare.row6': 'Prototype to production on one stack',
  'home.platform.compare.row7': 'Avg. monthly stack cost',
  'home.platform.compare.beta': 'Beta',
  'home.platform.compare.rollingOut': 'Rolling out',
  'home.platform.compare.payg': 'Pay-as-you-go',
  'home.platform.compare.multiVendor': 'Multiple Vendors',
  'home.platform.compare.infraAddons': 'Infra + Add-Ons',
  'home.platform.compare.cloudBill': 'Cloud Bill + Engineering Time',

  // ── Device Showcase ───────────────────────────────────────────────────────
  'home.devices.title': 'Your AI Stack, Everywhere',
  'home.devices.subtitle':
    'Monitor, manage, and deploy from any device. Full control wherever you are.',

  // ── Enterprise ────────────────────────────────────────────────────────────
  'home.enterprise.label': 'Global Infrastructure',
  'home.enterprise.titlePrefix': 'Enterprise-Grade,\n Now',
  'home.enterprise.titleHighlight': 'Yours',
  'home.enterprise.titleSuffix': ' To Build On.',
  'home.enterprise.subtitle':
    "7 years serving the world's top game studios. The same infrastructure proven at 3 million concurrent scale is now available for your products.",
  'home.enterprise.card1.title': 'Security & Compliance',
  'home.enterprise.card1.desc':
    'SOC 2 compliant infrastructure with encryption at rest and in transit. Role-based access control and audit logging.',
  'home.enterprise.card2.title': 'Custom Deployments',
  'home.enterprise.card2.desc':
    'Deploy to your own cloud, on-premises, or hybrid environments. Full control over data residency.',
  'home.enterprise.card3.title': 'SLA & Support',
  'home.enterprise.card3.desc':
    '99.99% uptime SLA with dedicated support and priority incident response for enterprise plans.',
  'home.enterprise.card4.title': 'Global Edge Network',
  'home.enterprise.card4.desc':
    'Low-latency access from 13+ regions worldwide. Automatic failover and intelligent traffic routing.',

  // ── Stats ─────────────────────────────────────────────────────────────────
  'home.stats.stat1': 'ANNUAL\n SERVICE EVENTS',
  'home.stats.stat2': 'PLAYER INTERACTIONS\n PER YEAR',
  'home.stats.stat3': 'PEAK CONCURRENT\n GAME AGENTS',
  'home.stats.stat4': 'DAILY ACTIVE\n GAME SESSIONS',

  // ── Process ───────────────────────────────────────────────────────────────
  'home.process.label': 'See It in Action',
  'home.process.titlePrefix': 'From Chat To Production\n In',
  'home.process.titleHighlight': 'Under A Minute.',
  'home.process.subtitle':
    'Tell Copilot what you need and watch it build, deploy, and go live.',
  'home.process.step1.title': 'Chat to Create',
  'home.process.step1.desc':
    'Describe what you need in natural language. Copilot turns the idea into a working workflow with no code required.',
  'home.process.step2.title': 'One-Click Launch',
  'home.process.step2.desc':
    'Ship to production instantly. Zero DevOps, with hosting and environment setup handled for you.',
  'home.process.step3.title': 'Monitor and Grow',
  'home.process.step3.desc':
    'Real-time monitoring and cost control are built in. End-user billing and monetization are coming soon.',
  'home.process.terminal.line1':
    'Build me a customer support agent that handles tickets and answers FAQs',
  'home.process.terminal.line2': 'Copilot is generating workflow...',
  'home.process.terminal.line3': 'Created: ticket management + FAQ lookup',
  'home.process.terminal.line4': 'Connected: knowledge base + AI routing',
  'home.process.terminal.line5': 'Deploying to production...',
  'home.process.terminal.line6': 'Monitoring enabled',
  'home.process.terminal.line7': 'Live at ',
  'home.process.terminal.line8': 'Live in 38s. $10 free credit applied.',

  // ── Pricing ───────────────────────────────────────────────────────────────
  'home.pricing.label': 'Pricing',
  'home.pricing.titlePrefix': 'Start With One Stack.\n Pay As',
  'home.pricing.titleHighlight': 'You Grow.',
  'home.pricing.subtitle':
    'Use Knit when the alternative is assembling infrastructure before you know what the product needs.',
  'home.pricing.freeCredit': 'FREE CREDIT',
  'home.pricing.payg': 'THEN PAY AS YOU GO',
  'home.pricing.desc':
    'Most teams spend $50K-$200K building hosting, monitoring, and infrastructure before reaching their first user. With Knit, you skip all of that and go live in minutes.',
  'home.pricing.feature1': 'Free credit on sign-up',
  'home.pricing.feature2': 'All features unlocked from day one',
  'home.pricing.feature3': 'Pay per agent run, API call, and compute',
  'home.pricing.feature4': 'Copilot workflow builder included',
  'home.pricing.feature5': 'Hosting, monitoring, and cost management',
  'home.pricing.feature6': 'Billing and monetization coming soon',
  'home.pricing.cta': 'Start building now',

  // ── Final CTA ─────────────────────────────────────────────────────────────
  'home.final.titlePrefix': 'Build The\n Product.\n',
  'home.final.titleHighlight': 'Ship Today.',
  'home.final.desc': `For teams shipping AI agents and apps, Knit turns years of
infrastructure work into one production-ready platform. Free to get
started. Zero lock-in.`,
  'home.final.cta': 'Start building for free',

  // ── Footer ────────────────────────────────────────────────────────────────
  'home.footer.copy':
    '© 2026 Knit. Production infrastructure for AI agents and apps.All rights reserved.',
  'home.footer.disclaimer':
    "* Cost savings based on internal benchmarks comparing Knit's pooled infrastructure pricing to standard on-demand rates from major cloud providers. Actual savings may vary by workload. Illustrative scenarios on this page represent typical use cases, not specific customers.",
  'home.footer.docs': 'Docs',
  'home.footer.github': 'GitHub',
  'home.footer.discord': 'Discord',
  'home.footer.twitter': 'Twitter',
  'home.footer.blog': 'Blog',
  'home.footer.pricing': 'Pricing',
  'home.footer.status': 'Status',
  'home.footer.privacy': 'Privacy Policy',
  'home.footer.terms': 'Terms of Use',
};
